/**
*  AUTHOR : 
*  WEBSITE :  sca.pearlgreen.com
*  DATE : 14-06-2019
*/

//@MODULE Catalogs

define(
   'Catalogs.Router'
,  [   
      'Catalogs.View'
   ,  'Catalogs.Model'
   ,  'Backbone'
	]
,  function (
      CatalogsView
   ,  CatalogsModel
   ,  Backbone
   )
{
   'use strict';

   //@class Address.Router @extend Backbone.Router
   return Backbone.Router.extend({

      routes: {
			'catalogs': 'CatalogsRouter'
      }

   ,   initialize: function (application)
      {
         this.application = application;
      }

	,   CatalogsRouter: function ()
		{
         var model = new CatalogsModel()
         ,  view = new CatalogsView({
               application: this.application
            ,  model: model
         });

         model.fetch().done(function(){
            view.showContent();
         });
      }
   });
});
